import axios from 'axios';
import { API_BASE, API_KEY } from '../config';
import { clearAdminProfile, clearToken, getToken } from '../auth/authStorage';

export const http = axios.create({
  baseURL: API_BASE,
  timeout: 60000,
});

let redirectingToLogin = false;

http.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  // Backend expects API key auth on every request.
  if (API_KEY) config.headers['x-api-key'] = API_KEY;

  // Protected admin endpoints also require the admin auth token.
  const token = getToken();
  if (token) {
    config.headers.token = token;
  }
  return config;
});

http.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      clearToken();
      clearAdminProfile();

      const url = String(err?.config?.url || '');
      const isLoginRequest = url.includes('/admin/login');
      const isAlreadyOnLogin =
        typeof window !== 'undefined' && window.location?.pathname === '/login';

      if (!redirectingToLogin && !isLoginRequest && !isAlreadyOnLogin) {
        redirectingToLogin = true;
        // Interceptor runs outside React Router context; a hard redirect is the safest.
        window.location.replace('/login');
      }
    }
    return Promise.reject(err);
  }
);

export function unwrapApiResponse(res) {
  // Backend returns ApiResponse: { statusCode, data, message }
  return res?.data?.data ?? res?.data;
}

